import { equals } from "ramda";
import type { Environment } from "app_constants";

function getEnv(): Environment {
  if (equals(location.host, "hq.upserve.com")) {
    return "production";
  } else if (equals(location.host, "hq.staging.upserve.com")) {
    return "staging";
  }
  return "development";
}

function isDevelopment(): boolean {
  return getEnv() === "development";
}

function isProduction(): boolean {
  return getEnv() === "production";
}

export default getEnv;
export { isDevelopment, isProduction };
